<template>
  <v-dialog v-model="dialog" persistent width="500">
    <v-card flat>
      <v-row class="d-flex flex-column pa-4">
        <!-------------------------------------CAMERA SCANNER-------------------------------------->
        <v-col v-if="!physicalScanner" xs="12" md="12" lg="12">
          <qrcode-stream
            v-if="dialog"
            :camera="constraints"
            :paused="pauseCam"
            @decode="decodeId"
          />
        </v-col>
        <!-------------------------------------PHYSICAL SCANNER------------------------------------>
        <v-col v-if="physicalScanner" xs="12" md="12" lg="12">
          <v-row class="pa-3 justify-center">
            <div
              v-if="foundId === false && !physicalScannerError"
              class="ma-3 blue--text subheading"
            >
              {{ $t("parts.inventory.id_changer.physical_scanner") }}
            </div>
            <div v-if="physicalScannerError" class="ma-3 red--text subheading">
              {{ $t("parts.inventory.id_changer.physical_scanner_error") }}
            </div>
          </v-row>
        </v-col>
        <!----------------------------------------------------------------------------------------->
        <v-col xs="12" md="12" lg="12">
          <v-row class="mt-2 d-flex flex-column align-center">
            <span v-if="foundId" class="green--text subheading">
              {{ $t("parts.inventory.id_changer.found_message") }}
              {{ decodedString }}
            </span>
            <div
              v-if="mode === 'switch' && otherPart"
              class="ma-3 text-center subheading"
            >
              {{
                $t("parts.inventory.id_changer.switch_confirm", {
                  title: otherPartTitle,
                  id: otherPart.shortId || "",
                })
              }}
            </div>
            <div v-if="ebayRelistWarning" class="ma-3 text-center">
              <v-alert type="warning" variant="tonal">
                {{
                  mode === "switch"
                    ? $t("parts.inventory.id_changer.ebay_relist_warning_switch")
                    : $t("parts.inventory.id_changer.ebay_relist_warning")
                }}
              </v-alert>
            </div>
            <div v-if="changeError" class="ma-3 red--text subheading text-center">
              <v-alert type="error" variant="tonal">
                {{ $t(changeError) }}
              </v-alert>
            </div>
            <v-btn
              v-if="foundId"
              variant="outlined"
              color="success"
              :loading="checking"
              :disabled="checking"
              @click="confirmScan"
            >
              {{
                mode === "switch"
                  ? $t("parts.inventory.id_changer.switch_id")
                  : $t("parts.inventory.id_changer.change_id")
              }}
            </v-btn>
          </v-row>
        </v-col>
        <v-col xs="12">
          <v-row align-center>
            <v-btn variant="text" icon @click="reScan">
              <v-icon>mdi-refresh</v-icon>
            </v-btn>
            <v-spacer />
            <v-btn variant="text" icon @click="switchScanner">
              <v-icon>mdi-qrcode-scan</v-icon>
            </v-btn>
            <v-btn variant="text" icon @click="switchQrCamera">
              <v-icon>mdi-camera-switch</v-icon>
            </v-btn>
            <v-btn variant="outlined" color="error" @click="close">
              {{ $t("parts.inventory.id_changer.close") }}
            </v-btn>
          </v-row>
        </v-col>
      </v-row>
    </v-card>
  </v-dialog>
</template>

<script>
import { QrcodeStream } from "vue3-qrcode-reader";
import getRequest from "../../api/getRequest";
import postRequest from "../../api/postRequest";
export default {
  components: {
    QrcodeStream,
  },
  data: () => ({
    dialog: false,
    front: false,
    pauseCam: false,
    foundId: false,
    constraints: {
      audio: false,
      video: {
        facingMode: "environment",
      },
    },
    decodedString: "",
    physicalScanner: false,
    physicalScannerError: false,
    buffer: "",
    partId: null,
    mode: "change",
    otherPart: null,
    changeError: "",
    checking: false,
    ebayRelistWarning: false,
  }),
  computed: {
    otherPartTitle() {
      const title = this.otherPart && this.otherPart.title;
      if (title && typeof title === "object") {
        return title.it || title.en || title.al || "-";
      }
      return title || "-";
    },
  },
  methods: {
    decodeId(value) {
      this.decodedString = value;
      this.foundId = true;
      this.pauseCam = true;
    },
    switchQrCamera() {
      this.physicalScanner = false;
      document.removeEventListener("keydown", this.listenToEvent);
      this.front = !this.front;
      this.constraints = {
        video: { facingMode: this.front ? "user" : "environment" },
        audio: false,
      };
    },
    switchScanner() {
      this.physicalScanner = true;
      document.addEventListener("keydown", this.listenToEvent);
    },
    listenToEvent(e) {
      if (e.key !== "Enter") {
        this.buffer += e.key;
      } else if (this.buffer.length > 24) {
        this.physicalScannerError = true;
        this.buffer = "";
      } else {
        this.decodeId(this.buffer);
        this.buffer = "";
      }
    },
    reScan() {
      this.decodedString = null;
      this.foundId = false;
      this.pauseCam = false;
      this.physicalScannerError = false;
      this.changeError = "";
      this.otherPart = null;
      this.ebayRelistWarning = false;
    },
    qrErrorKey(message) {
      const keyByMessage = {
        "Invalid QR code.": "parts.inventory.id_changer.errors.invalid",
        "This QR code is already assigned to another part.":
          "parts.inventory.id_changer.errors.already_assigned",
        "This QR code does not exist or was already used.":
          "parts.inventory.id_changer.errors.not_found",
        "This QR code belongs to another institution.":
          "parts.inventory.id_changer.errors.other_institution",
        "This QR code is already used by a part waiting for approval.":
          "parts.inventory.id_changer.errors.waiting_approval",
        "This QR code is unused. Use Change Part ID instead.":
          "parts.inventory.id_changer.errors.use_change_id",
        "This QR code belongs to the same part.":
          "parts.inventory.id_changer.errors.same_part",
        "This QR code does not belong to an inventory part.":
          "parts.inventory.id_changer.errors.not_inventory",
        "This part has no QR ID to swap.":
          "parts.inventory.id_changer.errors.no_qr",
        "This part has eBay listings. Delete the listings, then change the QR code.":
          "parts.inventory.id_changer.errors.ebay_listings",
      };
      if (typeof message === "string" && message.indexOf("Could not remove eBay listings") === 0) {
        return "parts.inventory.id_changer.errors.ebay_delist_failed";
      }
      return keyByMessage[message] || "parts.inventory.id_changer.errors.generic";
    },
    async confirmScan() {
      if (this.mode === "switch") {
        await this.confirmSwitch();
        return;
      }
      await this.changeId();
    },
    async changeId() {
      if (!this.decodedString || !this.partId || this.checking) return;
      this.checking = true;
      this.changeError = "";
      try {
        const check = await getRequest(
          "/part/edit/check-qr",
          `id=${this.decodedString}&part_id=${this.partId}`,
        );
        if (check && check.ebayRelist && !this.ebayRelistWarning) {
          this.ebayRelistWarning = true;
          return;
        }
        this.$emit("change", this.decodedString);
      } catch (error) {
        const message =
          error && error.response && error.response.data
            ? error.response.data
            : "";
        this.changeError = this.qrErrorKey(
          typeof message === "string" ? message : "",
        );
      } finally {
        this.checking = false;
      }
    },
    async confirmSwitch() {
      if (!this.decodedString || !this.partId || this.checking) return;
      this.checking = true;
      this.changeError = "";
      try {
        if (!this.otherPart) {
          const preview = await getRequest(
            "/part/switch-qr",
            `id=${this.decodedString}&part_id=${this.partId}`,
          );
          this.otherPart = preview && preview.otherPart ? preview.otherPart : null;
          if (preview && preview.ebayRelist) {
            this.ebayRelistWarning = true;
          }
          return;
        }
        const response = await postRequest.object("/part/switch-qr", {
          partId: this.partId,
          scannedId: this.decodedString,
        });
        const payload = response && response.data ? response.data : {};
        this.$emit("switched");
        if (payload.ebayError) {
          this.$emit("ebay-message", payload.ebayError);
        } else if (payload.ebayRelisted) {
          this.$emit(
            "ebay-message",
            this.$t("parts.inventory.id_changer.ebay_relist_message_switch"),
          );
        }
      } catch (error) {
        const message =
          error && error.response && error.response.data
            ? error.response.data
            : "";
        this.changeError = this.qrErrorKey(
          typeof message === "string" ? message : "",
        );
        this.otherPart = null;
      } finally {
        this.checking = false;
      }
    },
    open(partId, mode) {
      this.partId = partId || null;
      this.mode = mode === "switch" ? "switch" : "change";
      this.changeError = "";
      this.checking = false;
      this.otherPart = null;
      this.ebayRelistWarning = false;
      this.dialog = true;
    },
    close() {
      this.dialog = false;
      this.foundId = false;
      this.physicalScanner = false;
      this.physicalScannerError = false;
      this.changeError = "";
      this.checking = false;
      this.partId = null;
      this.mode = "change";
      this.otherPart = null;
      this.ebayRelistWarning = false;
      document.removeEventListener("keydown", this.listenToEvent);
      this.$emit("close");
    },
  },
};
</script>
